import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getFavourites, removeFromFavourites } from './actions'

const mapStateToProps = (state) => ({
    loading: state.getIn(['ui', 'entityStack', 'favourites', 'loading'], false),
    loaded: state.getIn(['ui', 'entityStack', 'favourites', 'loaded'], false),
    favouritesCollection: state.getIn(['ui', 'entityStack', 'favourites', 'entities'], List()),
})

const mapDispatchToProps = (dispatch) => bindActionCreators({ getFavourites, removeFromFavourites }, dispatch)

export default (FavouritesContentComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            favouritesCollection: IPropTypes.list.isRequired,
            getFavourites: PropTypes.func.isRequired,
            loaded: PropTypes.bool.isRequired,
            loading: PropTypes.bool.isRequired,
            removeFromFavourites: PropTypes.func.isRequired,
        }

        render() {
            return <FavouritesContentComponent {...this.props} />
        }
    }

    return HocConnect
}
